import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Card, Container, Table, Button, Form } from 'react-bootstrap';
import useScript from 'react-script-hook/lib/use-script';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
//translations
import { useTranslation } from 'react-i18next';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { cartSelector, setIsGiftOrder, setAppliedCoupon, setShippingFee, setDiscountCart, setErrorAmountPrice } from 'slices/cart';
import { companySelector } from 'slices/company';
// Utils-Redux
import { calculateShippingCosts } from 'components/cart/utils';
// CONSTANTS
import { responsive } from '../../constants';
//API
import { getRelatedProduct } from 'api/products';
import { getValidateCode } from 'api/invoices';
//components
import ItemList from 'components/itemList/item';
import Items from './items';
import OrderSummary from 'components/cart/OrderSummary';
import OrderStepper from 'components/cart/OrderStepper';
//helpers
import { goUp } from 'helpers';
//images
import emptyBag from 'assets/img/shopping_bag.png';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
////styles
import './cart.scss';


const Cart = () => {
  const { t } = useTranslation(['cart']);
  const dispatch = useDispatch();
  const discountCodeRef = useRef();
  const previousValueRef = useRef('');

  const { countItems, total, items, discountCart, shippingCosts, errorAmountPrice } = useSelector(cartSelector);
  const { data, name, paypal_sandbox, paypal_production, shipping_cost, min_purchase_for_free_shipping } =
    useSelector(companySelector);
  const [relatedProducts, setRelatedProducts] = useState([]);

  const {assignedLibrary} = useAssignedLibrary()

  const [isDiscoungBeingApplied, setIsDiscoungBeingApplied] = useState(false); //! TODO: guardar el detalle del pedido
  const [error, setError] = useState({ status: false, message: '' });

  const CLIENT = {
    sandbox: paypal_sandbox,
    production: paypal_production,
  };

  const CLIENT_ID = process.env.NODE_ENV === 'production' ? CLIENT.production : CLIENT.sandbox;

  useScript({
    src: `https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}&currency=EUR`,
  });

  const checkDiscount = async () => {
    setIsDiscoungBeingApplied(true);
    dispatch(setErrorAmountPrice(false));
    if (discountCodeRef.current.value !== '') {
      try {
        const { status, data } = await getValidateCode(discountCodeRef.current.value);
        if (status === 200) {
          if (data.valid) {
            const { discount_amount, discount_percent, type_discount } = data.promo_code;
            if (discount_percent > 0) {
              dispatch(
                setDiscountCart({
                  type: 'percentage',
                  quantity: discount_percent,
                  has_discount: true,
                }),
              );
            } else if (type_discount === 'gift_card') {
              dispatch(
                setDiscountCart({
                  type: type_discount,
                  quantity: discount_amount,
                  has_discount: true,
                }),
              );
            } else {
              dispatch(
                setDiscountCart({
                  type: '',
                  quantity: 0,
                  has_discount: false,
                }),
              );
              throw new Error('El valor del descuento debería ser mayor de 0.');
            }
          } else {
            setError({ status: true, message: 'errorApplyCode' });
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    setIsDiscoungBeingApplied(false);
  };

  const handleRelatedProducts = async () => {
    if (items[items?.length - 1] !== undefined) {
      let itemId = items[items?.length - 1]?.id;
      const fields = ['id', 'title', 'url', 'image', 'authors', 'type', 'price', 'has_stock', 'iva'].join(',');
      const { status, data } = await getRelatedProduct(itemId, { fields: fields });
      if (status === 200) {
        setRelatedProducts(data);
      }
    }
  };

  useEffect(() => {
    window.document.title = 'Carrito de compras | ' + name;
    goUp();
  }, []);

  useEffect(() => {
    // const calculatedShipping = calculateShippingCosts(shipping_cost, min_purchase_for_free_shipping, total);
    total && dispatch(setShippingFee(3.80));
    total && handleRelatedProducts();
  }, [total]);

  const controlChangesDiscountCode = (e) => {
    setError({ status: false, message: '' });
    const currentValue = e.target.value;
    if (previousValueRef.current !== currentValue) {
      dispatch(
        setDiscountCart({
          type: '',
          quantity: 0,
          has_discount: false,
        }),
      );
    }
    previousValueRef.current = currentValue;
    discountCodeRef.current.value = currentValue;
  };

  return (
    <Container fluid className="sm-fluid mainDiv mx-1">
      {countItems ? (
        <Row className="justify-content-center">
          <Col md={9}>
            <OrderStepper activeStep={0} />

            <Row className="">
              <Col md={12} lg={12} xs={12} className="ml-1">
                <Items isResume={false} />
              </Col>
            </Row>

            <Row className="discount mt-5">
              <Col md={6} lg={6} xs={12} className="d-flex justify-content-sm-center">
                <Row className="justify-content-center">
                  <Col md={11} lg={11} xs={11} className="">
                    <p>{t('tienesUnCodigo')}</p>
                  </Col>
                  <Col md={11} lg={11} xs={11} className="d-flex justify-content-sm-center justify-content-md-start">
                    <Form.Control className="mr-1 pl-0" ref={discountCodeRef} onChange={controlChangesDiscountCode} />
                    <Button className="blue-btn" onClick={checkDiscount} disabled={discountCart?.has_discount}>
                      {t('aplicar')}
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col md={6} lg={6} xs={12} className="d-flex justify-content-sm-center justify-content-md-end mt-3 mt-md-0">
                <Row className="justify-content-sm-center ">
                  <Col md={11} lg={11} xs={11} className="justify-content-sm-center justify-content-md-end">
                    <p className="text-center text-md-end pr-5">{t('nextStepShipping')}</p>
                  </Col>
                  <Col md={11} lg={11} xs={11} className="d-flex justify-content-sm-center justify-content-md-end">
                    {/* <Link
                      to={{
                        // pathname: '/shipping?gift',
                        // state: { discount: true, percentage: 25 },
                      }}
                    >
                      <Button onClick={() => dispatch(setIsGiftOrder(true))} className="white-btn p-2">
                        <FiGift className="mr-2" />
                        {t('comprarComoRegalo')}
                      </Button>
                    </Link> */}
                    <Link to={{ pathname: `/${assignedLibrary}/envio` }} className='mx-auto mx-md-0'>
                      <Button
                        onClick={() => dispatch(setIsGiftOrder(false))}
                        className="orange-btn ml-3 p-2"
                        disabled={isDiscoungBeingApplied}
                      >
                        {t('comprarParaMi')}
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </Col>
              {error.status && <small className="mt-2 text-danger">{t(error.message)}</small>}
              <small className="mt-2">{t('promoCodeWarning')}</small>
            </Row>
          </Col>

          {total && <OrderSummary activeStep={0} />}
        </Row>
      ) : (
        <Row>
          <Col>
              <Row className="noFavorites text-center">
                <Col lg={10} className="margin-bottom-md mt-5">
                  <img src={emptyBag} alt="bag.png" />
                </Col>
                <Col lg={10} className="margin-bottom-md">
                  <h2>{t('emptyCart')}</h2>
                  <p>{t('continueShopping')}</p>
                  <p>
                    {t('goBackCatalog')}
                    <Link to="/" className="">
                      {' '}{name}
                    </Link>
                  </p>
                  <Link to="/" className="">
                    <Button className="mt-4 p-3 w-initial">{t('goBackHome')}</Button>
                  </Link>
                </Col>
              </Row>
          </Col>
        </Row>
      )}
      {relatedProducts?.length > 0 && (
        <Row className="justify-content-center mt-5">
          <Col lg={9} className="p-0">
            <section className="margin-bottom-md list-section">
              <Row className="mb-3">
                <Col xs={12} sm={9}>
                  <h3>{t('relatedProducts')}</h3>
                </Col>
                <Col xs={12} sm={2} className="v-center"></Col>
              </Row>
              <Col xs={12} sm={12}>
                <Carousel
                  responsive={responsive}
                  slidesToSlide={1}
                  minimumTouchDrag={40}
                  draggable
                  infinite={true}
                  centerMode={false}
                  swipeable
                >
                  {relatedProducts.map((item, index) => (
                    <div key={`relatedProduct#${index}`} className="slide-div">
                      <ItemList data={item} />
                    </div>
                  ))}
                </Carousel>
              </Col>
            </section>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Cart;